import { format, setMonth } from "date-fns";
import { getDaysInMonth } from "date-fns/fp";

export const MAX_DAY_OF_MONTH = 31;
export const MAX_FEB_DAY_OF_MONTH = 28;
export const MIN_DAY_OF_MONTH = 1;
export const MONTHS_OPTIONS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
].map((label, index) => ({ label, value: String(index) }));

export function getMaxMonthDayByZeroBasedMonth(month?: number): number {
  if (month == null) {
    return MAX_DAY_OF_MONTH;
  }

  if (month === 1) {
    return MAX_FEB_DAY_OF_MONTH;
  }

  const dateByMonth = setMonth(new Date(), month);

  return getDaysInMonth(dateByMonth);
}

export function getShortFormattedDate(
  date: Date | string | null,
  locale?: Locale
): string {
  if (!date) return "";

  return format(new Date(date), "dd.MM.yyyy", { locale });
}

export function getDateWithUserTimezoneOffset(date: Date): Date {
  const offsetInMilliseconds = date.getTimezoneOffset() * 60000;

  return new Date(date.getTime() + offsetInMilliseconds);
}

// Use `useLocalizedDateFormatter` to get localized version of this util
const getDateText = (date: Date | string | null, locale?: Locale): string => {
  if (!date) return "";

  return format(new Date(date), "dd MMM yyyy", { locale });
};

export const convertToDateWithoutTime = (date: Date): string => {
  const selectedDate = new Date(date);
  const adjustedMonth = selectedDate.getUTCMonth() + 1;
  return `${selectedDate.getUTCFullYear()}-${
    adjustedMonth > 9 ? adjustedMonth : "0" + adjustedMonth
  }-${
    selectedDate.getUTCDate() > 9
      ? selectedDate.getUTCDate()
      : "0" + selectedDate.getUTCDate()
  }`;
};

export function convertIntToDisplay(
  locale: string,
  incomingNumber: number
): string {
  return new Intl.NumberFormat(locale.replace("_", "-"), {
    style: "decimal",
  }).format(incomingNumber);
}

export function convertDateToNoonDateTime(value: string): string {
  return `${value}T12:00:00`;
}

export function getShortFormattedDateWithTime(
  date: Date | string | null
): string {
  if (!date) return "";

  return format(new Date(date), "dd.MM.yyyy hh:mm");
}

const formatMin = (m = 0, language = "de_DE"): string => {
  if (m === 0) {
    return "0 h";
  }

  const sign = m.toString().startsWith("-") ? "-" : "";
  const positive = Math.abs(m);
  const h = Math.floor(positive / 60);
  const min = Math.floor(positive % 60);
  const minutes = min === 0 ? "" : `${convertIntToDisplay(language, min)} min`;
  const hours = h === 0 ? "" : `${convertIntToDisplay(language, h)} h`;

  return `${sign} ${hours} ${minutes}`;
};

const isDateToday = (date: Date): boolean => {
  return new Date().toDateString() === date.toDateString();
};

export { getDateText, formatMin, isDateToday };

export const DAY_LABLES = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
